module.exports = __webpack_public_path__ + "img/group.3aa08591.svg";